<template>
  <div class="data-analysis">
    <div class="scan-title">扫码数据分析-{{ param }}</div>
    <div class="scan-qrcode-btns">
      <el-button plain type="primary" size="medium" @click="todayScanCount">
        今日扫码量
        <span class="count-data">{{ todayCount }}次</span>
      </el-button>
      <el-button plain type="primary" size="medium" @click="currentMonthScanCount">
        本月扫码量
        <span class="count-data">{{ currentMonthCount }}次</span>
      </el-button>
      <el-button plain type="primary" size="medium" @click="totalScanCount">
        累计扫码量
        <span class="count-data">{{ totalCount }}次</span>
      </el-button>
    </div>
    <div class="scan-echarts" id="echarts"></div>
    <div class="table-data">
      <el-table
        v-loading="loadingDate"
        :data="scanUserInfo"
        size="mini"
      >
        <el-table-column align="center" label="用户id" prop="userId"></el-table-column>
        <el-table-column align="center" label="头像">
          <template slot-scope="scope">
            <el-image style="width: 20%;border-radius: 50%" :src="scope.row.avatar"/>
          </template>
        </el-table-column>
        <el-table-column align="center" label="登录名" prop="nickName">

        </el-table-column>
        <el-table-column align="center" label="剩余金额" prop="remainder">

        </el-table-column>
        <el-table-column align="center" label="账户明细">
          <template slot-scope="scope1">
            <el-button type="text" @click="accountDetail(scope1.$index,scope1.row)">查看</el-button>
          </template>
        </el-table-column>
        <el-table-column align="center" label="累计扫码">
          <template slot-scope="scope2">
            <el-button type="text" @click="showScanInfo(scope2.row.userId)">{{ scope2.row.scAcount }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-col :span="24" class="toolbar">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[3, 10, 20, 30, 40]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalRecord">
        </el-pagination>
      </el-col>
    </div>
    <el-dialog title="扫码记录" :visible.sync="isShowScanDialog" width="60%">
      <el-table :data="scanQrcodeRecord">
        <el-table-column align="center" label="序号" type="index" width="80px"></el-table-column>
        <el-table-column align="center" label="扫码时间" prop="scanTime" width="150px"></el-table-column>
        <el-table-column align="center" label="活动名称" prop="activeName" width="300px"></el-table-column>
        <el-table-column align="center" label="活动链接">
          <template slot-scope="activeLinkScope">
            <span style="font-size: 4px">{{activeLinkScope.row.activeLink}}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
  import echarts from 'echarts'
  import {hourofday} from './fixation.js'

  export default {
    name: "data-analysis",
    data() {
      return {
        todayCount: 0,
        currentMonthCount: 0,
        totalCount: 0,
        xAxis: null,
        yAxis: null,
        loadingDate: false,
        scanUserInfo: [],
        pageSize: 3,
        currentPage: 0,
        totalRecord: 0,
        param: null,
        isShowScanDialog: false,
        scanQrcodeRecord: null,
      }
    },
    methods: {
      loadEchartsForScanQrcode(showLabel) {
        var myChart = echarts.init(document.getElementById('echarts'), 'light');
        myChart.setOption({
          legend: {
            left: '40%'
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross'
            }
          },
          grid: {
            left: '4%'
            /*tooltip: {
              axisPointer: {
                type: 'cross'
              }
            }*/
          },
          xAxis: {
            minInterval: 1,
            name: '时间',
            data: this.xAxis,
            axisTick: {
              show: false,
              inside: true,
              alignWithLabel: true
            },
            axisLine: {
              show: true
            },
            axisLabel: {
              show: showLabel,
              margin: 10,
              formatter: function (value, index) {
                return value.replace(' ', '\n')
              }
            },
          },
          yAxis: {
            name: '扫码次数',
            position: 'left',
            // splitLine: false
          },
          series: [{
            name: '扫码次数',
            type: 'line',
            smooth: true,
            data: this.yAxis
          }]
        });
      },
      todayScanCount() {
        this.xAxis = []
        this.yAxis = []
        this.xAxis = hourofday;
        this.$http.post(this, '/qrcode/todayScCount', {param: this.param}).then(res => {
          res.data.forEach((count, index) => {
            if (count == null) {
              res.data[index] = 0
            }
          })
          this.yAxis = res.data
          this.loadEchartsForScanQrcode(true)
        })
      },
      currentMonthScanCount() {
        let that = this
        that.xAxis = []
        that.yAxis = []
        let currnetTime = new Date().format("yyyy-MM")
        this.$http.post(this, '/qrcode/currentMonthScanCount', {param: this.param}).then(res => {
          res.data.forEach((list, index) => {
            if (null == list) {
              res.data[index] = []
              res.data[index][0] = currnetTime + "-" + (index + 1)
              res.data[index][1] = 0
            } else {
              res.data[index][1] = parseInt(res.data[index][1])
            }
            that.xAxis.push(res.data[index][0])
            that.yAxis.push(res.data[index][1])
          })
          this.loadEchartsForScanQrcode(true)
        })
      },
      totalScanCount() {
        let that = this
        that.xAxis = []
        that.yAxis = []
        this.$http.post(this, '/qrcode/totalScanCount', {param: this.param}).then(res => {
          if (res) {
            res.data.forEach(list => {
              that.xAxis.push((list[0] + '-' + list[2]).replace(' ', '\n'))
              that.yAxis.push(list[1])
            })
          }
          this.loadEchartsForScanQrcode(false)
        })
      },
      accountDetail(index, row) {
        this.$router.push({path: '/users/details', query: {userId: row.userId, userName: row.nickName}});
      },
      handleSizeChange(val) {
        this.pageSize = val
        this.loadUserInfo()
      },
      handleCurrentChange(val) {
        this.currentPage = val
        this.loadUserInfo()
      },
      loadUserInfo() {
        let that = this
        let params = {
          param: this.param,
          pageSize: this.pageSize,
          currentPage: this.currentPage == 0 ? this.currentPage : this.currentPage - 1
        }
        this.$http.post(this, '/qrcode/loadUserInfo', params).then(res => {
          this.totalRecord = res.data.count
          that.scanUserInfo = res.data.data.map((item) => {
            return that.formatUserInfo(item)
          })
        })
      },
      formatUserInfo(item) {
        return {
          userId: item.userId,
          avatar: item.avatar,
          nickName: item.nickName,
          remainder: item.remainder,
          scAcount: item.scAcount
        }
      },
      showScanInfo(userId) {
        let that = this
        this.$http.post(this, '/qrcode/scanQrcodeRecord', {userId: userId, param: this.param}).then(res => {
          console.log(res);
          that.scanQrcodeRecord = res.data.map(item => {
            return that.formatRecord(item)
          })
          that.isShowScanDialog = true
        })
      },
      formatRecord(item) {
        return {
          scanTime: new Date(item.createTime).format('yyyy-MM-dd hh:mm'),
          activeName: item.title,
          activeLink: item.activeLink
        }
      },
      scanQrCodeAmount() {
        this.$http.post(this, '/qrcode/scanQrCodeAmount', {param: this.param}).then(res => {
          console.log(res);
          this.todayCount = res.data.todayTotalRecord == null ? 0 : res.data.todayTotalRecord
          this.currentMonthCount = res.data.currentMonthTotalRecord == null ? 0 : res.data.currentMonthTotalRecord
          this.totalCount = res.data.totalScanAmount == null ? 0 : res.data.totalScanAmount
        })
      }
    },
    mounted: function () {
      this.param = this.$route.query.param;
      this.todayScanCount()
      this.loadUserInfo()
      this.scanQrCodeAmount()
    }
  }
</script>

<style scoped>
  .count-data {
    display: block;
    font-size: 5px;
  }

  .scan-title {
    font-size: 25px;
  }

  .scan-qrcode-btns {
    margin-top: 1%;
  }

  .scan-echarts {
    width: 100%;
    height: 350px;
    margin-top: 1%;
  }

  .data-analysis {
    width: 100%;
    height: 100%;
  }

  .table-data {
    height: 40%;
  }
</style>
